import * as Cookies from "js-cookie";
import React from 'react'
import {v4 as uuidv4} from 'uuid';

// max cookie size is 4096 bytes so keep this to a min
export const setDeviceContext = (session) => {
  const device = {
    deviceId: session.deviceId,
    timestamp: session.timestamp
  }
  Cookies.set("deviceContext", device);
};

export function getDeviceId() {
  const deviceContext = getDeviceContext();
  if (deviceContext.deviceId) {
    return deviceContext.deviceId;
  } else {
    const uniqueId = uuidv4();
    setDeviceContext({deviceId: uniqueId, timestamp: Date.now()})
    return uniqueId;
  }
}
// max cookie size is 4096 bytes so keep this to a min
export const setSessionCookie = (session) => {
  const truncSession = {
    profile: session.profile,
    hasProfile: session.hasProfile,
    photo: session.photo,
    firstName: session.firstName,
    userName: session.userName,
    lastName: session.lastName,
    studentType: session.studentType,
    college: session.college,
    organization: session.organization,
    email: session.email,
    dateOfBirth: session.dateOfBirth,
    phone: session.phone,
    companyId: session.companyId,
    referralLink: session.referralLink,
    ambassadorData: session.ambassadorData,
    timestamp: session.timestamp,
    jwt: session.jwt,
  }
  Cookies.set("session", truncSession, { expires: 14 });
};

export const clearSessionCookie = () => {
  Cookies.remove("session");
};

export const clearDeviceContextCookie = () => {
  Cookies.remove("deviceContext");
};

export const isMentor = (session) => {
  if (window.location.href.endsWith('/partners')) {
    return false;
  }

  return session.studentType === "CURRENT"
};

export const isAmbassador = () => {
  if (window.location.href.endsWith('/partners')) {
    return true;
  }
};

export const isMentee = (session) => {
  if (window.location.href.endsWith('/partners')) {
    return false;
  }

  return session.studentType === "PROSPECTIVE"
};

export const isStudent = (session) => {
  if (window.location.href.endsWith('/partners')) {
    return false;
  }

  return isMentor(session) || isMentee(session)
}

export const isPartner = (session) => {
  return session.organization && session.studentType !== "PROSPECTIVE" && session.studentType !== "CURRENT"
};

export const isEmployer = (session) => {
  return session.companyId && session.studentType === "EMPLOYEE" && session.studentType !== "PROSPECTIVE" && session.studentType !== "CURRENT" && !session.organization
};

export const isLoggedIn = () => {
  const sessionCookie = Cookies.get("session");

  if (!sessionCookie) {
    return false;
  }

  if (window.location.href.endsWith('/partners')) {
    return false;
  }

  const jsonSessionCookie = JSON.parse(Cookies.get("session"))
  return (jsonSessionCookie.jwt !== undefined
      && jsonSessionCookie.jwt !== 'undefined'
      && jsonSessionCookie?.jwt !== 0);

}

export const getSessionCookie = () => {
  const sessionCookie = Cookies.get("session");
  if (sessionCookie === undefined || sessionCookie === 'undefined') {
    return {};
  } else {
    return JSON.parse(sessionCookie);
  }
};


export const getDeviceContext = () => {
  const deviceContext = Cookies.get("deviceContext");
  if (deviceContext === undefined || deviceContext === 'undefined') {
    return {};
  } else {
    return JSON.parse(deviceContext);
  }
};

export const SessionContext = React.createContext({
  session: getSessionCookie(),
  refreshSession:  () => {}
});

export const DeviceContext = React.createContext({
  deviceContext: getDeviceContext(),
  refreshDeviceContext:  () => {}
});
